/* eslint-disable import/no-unresolved */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCustom from 'customLocales/en/default.json';
import esCustom from 'customLocales/es/default.json';
import en from './locales/en/default.json';
import de from './locales/de/default.json';
import es from './locales/es/default.json';

const resources = {
  en: {
    translation: {
      ...en,
      ...enCustom,
    },
  },
  es: {
    translation: {
      ...es,
      ...esCustom,
    },
  },
  de: {
    translation: { ...de },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: true,
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],

    // Language detection options
    detection: {
      order: ['navigator', 'localStorage', 'sessionStorage', 'cookie', 'htmlTag'],
      caches: ['localStorage', 'sessionStorage'], // Cache the detected language
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      cookieMinutes: 10080, // 7 days
    },

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

// Function to get the current language
export const getCurrentLanguage = () => {
  const language = localStorage.getItem('language');
  if (language) {
    i18n.changeLanguage(language).then();
  }
  return language || i18n.language;
};

// Function to switch language
export const switchLanguage = (languageCode) => {
  localStorage.setItem('language', languageCode);
  i18n.changeLanguage(languageCode).then();
};

export default i18n;
